import { LanguageSchema } from "@/assets/lang";

const en: LanguageSchema = {
  "title": "Octopus",
  "button": {
    "cancel": "Cancel",
    "ok": "OK",
    "discardChanges": "Reject changes",
    "search": "Browse",
    "confirm": "Confirm",
    "choose": "Select",
    "forward": "Next",
    "back": "Back",
    "reset": "Back",
    "apply": "Apply",
    "login": "Log in",
    "logout": "Log out",
    "send": "Submit",
    "backToStart": "Back to start",
    "backToLogin": "Back to login",
    "no": "No",
    "yes": "Yes",
    "toPayment": "For payment",
    "finishOrder": "Place order",
    "thank": "Thank you",
    "sendInvite": "Send invitation",
    "resend": "Resend",
    "startNow": "Start now",
    "skip": "Skip",
    "register": "Register now",
    "registerNoCode": "Register without code",
    "save": "Save",
    "saveChanges": "Apply changes",
    "delete": "{target} delete",
    "addCart": "Add list to shopping cart",
    "orderNow": "Order now",
    "add": "Add to",
    "changePassword": "Change password",
    "changeLogin": "Change login details",
    "changeEmail": "Change email",
    "edit": "Edit",
    "share": "Share",
    "delivererNotFound": "Supplier not found?",
    "joinLocation": "Join team",
    "createLocation": "Create location",
    "editSupplier": "Supplier @.lower:button.edit",
    "create": "Create",
    "deleteSupplier": "Delete supplier",
    "forwardApp": "Go to the app",
    "endIntro": "Finish introduction",
    "upload": "Upload",
    "showMore": "show more",
    "hide": "hide",
    "deleteAll": "Delete all",
    "settings": "Settings",
    "manualSort": "Edit manual sort",
    "switchOldVersion": "To the old version",
    "goToAppVersion": "Use Octopus in the browser",
    "updateList": "Add to list",
    "updateCart": "Add to basket",
    "openCameraScanner": "Open camera scanner",
    "orderOverview": "To the order overview",
    "deleteSupplierCart": "Delete shopping basket",
    "resetAmount": "Reset product quantities",
    "requestAiCall": "Request AI call",
    "filter": {
      "all": "All",
      "promotion": "Promotions",
      "productSuggestion": "Inspirations"
    }
  },
  "input": {
    "text": "Text",
    "password": "Password | Passwords",
    "email": "Email",
    "number": "Number",
    "url": "Link",
    "tel": "Phone",
    "search": "Search",
    "date": "Date",
    "orderDate": "Order date",
    "datetime": "Date",
    "datetime-local": "Time local time",
    "month": "Month",
    "week": "Week",
    "time": "Time",
    "range": "Scale",
    "color": "Colour"
  },
  "table": {
    "empty": "Table does not select elements"
  },
  "label": {
    "confirm": "confirm",
    "pwConfirm": "@:input.password @:label.confirm",
    "newReminder": "Add new order alarm",
    "selectPlaceholder": "Please select",
    "orderHint": "Note from the supplier",
    "selectTitle": "Select",
    "date": "@:input.date",
    "time": "Time",
    "dateTime": "@:label.date and @:label.time",
    "sum": "Total",
    "orderDetails": "Invoice details",
    "promoCode": "Coupon code",
    "orderNumber": "Order number",
    "octopusId": "Octopus ID",
    "orderMessage": "Order message",
    "description": "Description",
    "sort": "Sort",
    "priceRange": "Price range",
    "login": "Please log in",
    "user": "User",
    "newEmail": "New email",
    "oldPassword": "Old @:input.password",
    "password": "@:input.password",
    "pwForget": "@:input.password forgotten",
    "contactData": "Contact details",
    "name": "Name",
    "list": "List",
    "type": "Type",
    "zip": "POSTCODE",
    "city": "City",
    "street": "Address",
    "streetNumber": "House number",
    "phone": "Phone",
    "fax": "Fax",
    "streetName": "Street name",
    "postalCode": "@:label.zip",
    "deliverer": "@:object.deliverer",
    "customerNumber": "Customer number/outlet number",
    "quickstart": "Quickstart code",
    "email": "@:input.email",
    "firstName": "First name",
    "lastName": "Name",
    "dark": "Dark",
    "light": "Light",
    "standard": "System setting",
    "amount": "Quantity",
    "multipleAmount": "quantity must be a multiple of {target}",
    "maxAmount": "Maximum {target} item",
    "standardList": "Standard list",
    "language": "Language",
    "aiCallLanguage": "Call language",
    "oldMessages": "Older news",
    "notification": {
      "allow": "Allow messages"
    },
    "permission": {
      "order": "@:object.order",
      "promotion": "@:object.promotion",
      "message": "@:object.message",
      "news": "News",
      "reminder": "Order reminder",
      "productPromotion": "Product suggestions",
      "sub": {
        "newOrder": "New orders",
        "updateStatus": "Order update",
        "added": "New promotion",
        "ending": "Promotion at",
        "general": "General"
      },
      "mode": {
        "push": "Push message",
        "email": "Email notification",
        "popup": "Popup"
      }
    },
    "teamRole": {
      "admin": "Admin",
      "user": "Team member Pro",
      "device": "Team member base",
      "OWNER": "Owner"
    },
    "teamRoleShort": {
      "admin": "Admin",
      "user": "Pro",
      "device": "Base",
      "OWNER": "Owner"
    },
    "support": {
      "general": "Octopus Support",
      "gastro": "Team Customer Service Gastro",
      "technical": "Team Technical Customer Service",
      "technicalLead": "Technical Leader",
      "distribution": "Authorised signatory, marketing, sales",
      "service": "Team Customer Service"
    },
    "loading": {
      "location": "Loading @:object.location"
    },
    "onAccount": "Invoice",
    "onAccountOrCash": "Invoice or cash",
    "ON_ACCOUNT": "@:label.onAccount",
    "UNSPECIFIED": "not specified",
    "CASH": "@:label.cash",
    "cash": "Bar",
    "bar": "Bar / pub",
    "office": "Office",
    "coffeeShop": "Café / Bistro",
    "caterer": "Caterer / canteen / clubs",
    "club": "Club / discotheque",
    "EVENT": "Event",
    "DEALER": "Merchant",
    "takeAway": "Snack bar / Kiosk / Take-Away",
    "canteen": "Canteen",
    "restaurant": "Restaurant",
    "hotel": "Hotel",
    "spaetshop": "Petrol station / late-night shop",
    "getraenkehaendler": "Drinks retailer",
    "getraenkeabholmarkt": "Beverage collection market",
    "STAR_GASTRONOMY": "Star gastronomy",
    "SYSTEM_GASTRONOMY": "System catering",
    "spaetShop": "Late shop",
    "impress": "Imprint",
    "termsOfUse": "Terms of use",
    "agreeAGB1": "I agree to the",
    "agreeAGB2": "Privacy Policy",
    "agreeAGB3": "to",
    "category": "Category",
    "noCategory": "Without category",
    "editTags": "Create own categories",
    "selectDeliverer": "Select @:object.deliverer",
    "threeChars": "Enter at least three characters to get search results",
    "offlineMode": "Offline mode",
    "disable": "deactivate",
    "enable": "activate",
    "at": "at",
    "atTime": "at",
    "and": "and",
    "customerNo": "Customer number",
    "current": "Current",
    "tags": "Filter categories",
    "ownCategories": "Own categories",
    "supplierCategories": "Supplier categories",
    "noFilter": "No filter",
    "quantity": "Quantity",
    "quantityBiggerZero": "With quantity",
    "or": "or",
    "delivererType": {
      "online": "Online",
      "offline": "Offline"
    },
    "deleted": "Deleted",
    "resetAmount": "Reset product quantity after order",
    "compatibilityMode": "Compatibility mode",
    "timeIssueDelivery": "The delivery date you specified is in the past. Please choose a later date.",
    "timeIssuePickup": "The collection time you entered is in the past. Please choose a later date.",
    "wait": "Please wait",
    "day": "Tag",
    "month": "Month",
    "all": "All",
    "articleNo": "Item no.",
    "targetStock": "Target quantity",
    "targetStockShort": "Target",
    "resetProductQuantity": "By activating the slider, the product quantity is reset to zero after successful transmission of your order. If you do not activate it, the product quantity remains pre-filled for the next processing of your list.",
    "offlineMode1": "The offline mode gives you the possibility to synchronise your list and manage it without an internet connection.",
    "offlineMode2": "When you exit offline mode, all changes are synchronised with the server.",
    "darkMode": "Dark mode",
    "compatibilityText": {
      "activate": "Activate this mode if you want to edit the product quantities in your list in the app but place the order via the web portal.",
      "webPortal": "As long as this mode is activated, the list quantity is synchronised with the web portal and it is not possible to order this list via the app.",
      "deactivate": "Deactivate this mode if you want to order via the app."
    },
    "newProductSuggestion": "New product proposal",
    "files": "Files",
    "issue": "Problem",
    "place": "Location",
    "expectation": "Expectation",
    "steps": "Steps",
    "availability": "Availability",
    "availableFrom": "Available at",
    "deletedLocations": "Deleted locations",
    "reducedListDesign": "Reduced list design",
    "reducedListDesignDescription": "The reduced list design changes the view of your list. Product images are hidden, but additional buttons are displayed for operation.",
    "insert": "insert",
    "camera": "Camera scanner",
    "scanner": "Scanner",
    "picture": {
      "takePicture": "Take a photo",
      "selectPicture": "Select picture",
      "editPicture": "Edit picture",
      "removePicture": "Remove picture"
    },
    "uncategorized": "Uncategorized",
    "orderDataLoading": "Order data is loaded.",
    "screenshot": "Screenshot",
    "uploadImage": "Upload image",
    "aiCallbackPhone": "Store telephone number for callback"
  },
  "error": {
    "addReminder": "Order alarm could not be assigned to a list",
    "noMatch": "{target} does not match",
    "notFound": "{target} was not found. | {target} were not found.",
    "invalid": "{target} is not correct. | {target} are not correct.",
    "empty": "{target} is empty. | {target} are empty.",
    "noAuth": "{target} does not have permission. | {target} do not have permission.",
    "noAdmin": "No admin permission found.",
    "addCart": "Product could not be added to the shopping cart. | product could not be added to the shopping cart.",
    "addPromoPackage": "The promotional package was not added to the shopping basket or only partially added.",
    "addList": "Product could not be added to the list. | Products could not be added to the list.",
    "create": "{target} could not be created. | {target} could not be created.",
    "order": "Order could not be processed.",
    "save": "{target} could not be saved.",
    "delete": "{target} could not be deleted.",
    "deleteUser": "User could not be deleted.",
    "resendMail": "Email could not be resent.",
    "sendLink": "Link could not be sent.",
    "removeProduct": "Product could not be removed from shopping cart. | Product could not be removed from the shopping cart.",
    "registerFalse": "Registration failed.",
    "loginFalse": "Login failed.",
    "locationFalse": "Location creation failed.",
    "orderFinish": "Order could not be created.",
    "send": "{target} could not be sent.",
    "loadSupplier": "Supplier could not be loaded | Suppliers could not be loaded.",
    "loadLists": "Lists could not be loaded.",
    "load": "{target} could not be loaded. | {target} could not be loaded.",
    "sendTicket": "The feedback could not be sent.",
    "scanBarcode": "The scanned barcode is invalid.",
    "promotionLimitReached": "Max. Action quantity reached",
    "aiCall": "@:error.returnType.Unknown",
    "ajv": {
      "required": "Mandatory fields are not filled in",
      "format": "Input was not correct: The input should be in the format {formatInfo}.",
      "formatInfo": {
        "date": "Date",
        "time": "Time",
        "email": "Email",
        "date-time": "Date & Time"
      },
      "oneOf": "Input does not match any of the possible values",
      "minimum": "Input falls below minimum of {min}",
      "maximum": "Input exceeds maximum of {max}",
      "enum": "Input does not contain one of the possible values"
    },
    "returnType": {
      "Unknown": "An error has occurred",
      "BadRequest": "Request contains incorrect data",
      "NotFound": "Request did not find an element.",
      "Unauthorized": "Missing authorisation",
      "Forbidden": "Request is not allowed",
      "NotImplemented": "Request is not implemented",
      "InvalidLogin": "Invalid login",
      "InvalidSession": "Invalid session",
      "InvalidPassword": "Invalid password",
      "UserNotFound": "User not found",
      "UserAlreadyExists": "User already exists",
      "UserEmailAlreadyExists": "A user with this email already exists",
      "LocationNotFound": "Location not found",
      "CartItemNotFound": "Product not found",
      "ItemAlreadyInCart": "Product is already in the shopping cart, edit your selection in the shopping cart",
      "ListAlreadyInCart": "List is already in the shopping cart, edit your selection in the shopping cart. The list can only be edited once the list has been ordered in the shopping cart.",
      "ListCantBeDeleted": "List cannot be deleted.",
      "ListEmpty": "The list is empty. Check if at least one product has a quantity of more than 0.",
      "SupplierNotFound": "Supplier not found",
      "SupplierItemNotFound": "Supplier product not found",
      "OrderNotFound": "Order not found",
      "ListNotFound": "List not found",
      "ListItemNotFound": "List product not found",
      "ItemAlreadyInList": "Product is already in list, edit your selection in the list",
      "ItemNotFromListSupplier": "Product is not from supplier of this list",
      "NotificationNotFound": "Notification not found",
      "TagNotFound": "Category not found",
      "TagAlreadyExists": "Category already exists",
      "UserNotInTeam": "This user is not in the team",
      "TokenInvalid": "The code entered is invalid",
      "ReminderNotFound": "The order reminder was not found",
      "OwnerCantBeEdited": "The owner is not allowed to edit",
      "PromoCodeInvalid": "Coupon code is not valid",
      "PromoCodeInvalidAlreadyExists": "Coupon code has already been used",
      "QuickStartCodeInvalid": "Quickstart code is invalid",
      "SupplierAlreadyExists": "Supplier already exists",
      "SupplierCustomerInvalid": "Location supplier is invalid",
      "LocationAlreadyExists": "Location already exists",
      "JavaApiInternalServerError": "An error has occurred",
      "NewsNotFound": "Message not found",
      "OrderMessageTooLong": "Order message exceeds maximum length",
      "EmailInvalid": "Email is invalid",
      "TokenInvalidAlreadyUsed": "The code entered has already been used",
      "SupplierBlocked": "The supplier is blocked",
      "PromotionExpired": "Promotional item expired"
    },
    "scannedProductNotAvailable": "The scanned product is not available in your supplier's catalogue, therefore it cannot be added to the scanner list.",
    "scannerNotAvailable": "There is no scanner connected to your device. Please connect to a scanner or check your existing connection"
  },
  "error.": "An error has occurred",
  "target": {
    "username": "Username",
    "user": "User",
    "userAndPw": "@:target.username and @:input.password",
    "setting": "Setting | Settings",
    "profile": "Profile",
    "location": "Location",
    "order": {
      "paypal": "PayPal"
    },
    "product": "Product | Products",
    "request": "Request",
    "list": "List",
    "required": "Mandatory field",
    "field": "Field | Fields",
    "deliverer": "Supplier | Suppliers",
    "tag": "Category | Categories",
    "password": "Password",
    "permission": "Authorisation | Permissions"
  },
  "messages": {
    "orderFrom": "Order from",
    "mobileWeb": "We noticed that you are trying to open the Octopus Order web version from a mobile device. For a better user experience, we recommend that you download the mobile app from your app store on mobile devices and use it instead of the web version.",
    "mobileWeb2": "The following links will take you to the Octopus Order mobile app:",
    "setting": {
      "location": "Edit your location",
      "profile": "Edit your user profile",
      "delivererAssign": "Assign a supplier to your location",
      "delivererSelect": "Select supplier",
      "inputCustomerNr": "Enter customer number",
      "changeLocation": "Change location",
      "welcome1": "Hello {name}",
      "welcome2": "Here you can choose",
      "welcome3": "which representation you prefer"
    },
    "emptyCart": "Sorry, your shopping cart is empty.",
    "emptySuggestion": "Sorry, we don't have any product suggestions for you at the moment.",
    "card": {
      "forwardPoints": "Click here to be redirected to our @:object.pointSystem",
      "points": "Octopus points",
      "shop": "To the Octopus shop",
      "currentPromotion": "Current promotions",
      "createLocationExplanation": "A location can be a bar, restaurant, hotel, office or similar business.",
      "productSuggestion": "Product news and suggestions"
    },
    "noPromotion": "Sorry, we don't have any promotions for you at the moment.",
    "promotion": {
      "order": "Orderable at",
      "octopus": "Octopus promotions",
      "deliverer": "Promotions from your suppliers",
      "articles": "These articles have a special price at the moment"
    },
    "home": {
      "createLocation": "New @:messages.location.create",
      "welcome1": "Hello {name}",
      "welcome2": "which location would you like?",
      "image1": "Mixed, tapped, ordered!",
      "image2": "Secure, digital, order!",
      "image3": "Simple, fast, deliver!"
    },
    "dashboard": {
      "catalog": {
        "availableProduct": "All available articles",
        "delivererCatalog": "Assortment of the supplier",
        "createProduct": "Add product",
        "createdCustomProduct": "Product has been added to list.",
        "noReducedSupplier": "Currently, none of your suppliers are offering deals."
      },
      "home": {
        "orders": "Your last orders",
        "favouriteList": "Your last ordered lists",
        "news": "Octopus News"
      },
      "list": {
        "allLists": "All lists of this location",
        "createList": "New @:titleRoute.addList",
        "noSupplier": "You have not yet added a supplier to your location. Please add a supplier via the settings."
      },
      "message": {
        "available": "News available"
      },
      "setting": {
        "order": "Everything about your orders at a glance",
        "team": "Overview and management of your team",
        "deliverer": "Here you can see your suppliers",
        "notification": "Manage your notifications here",
        "display": "Choose between Dark or Light Mode",
        "statistic": "Here you can view your evaluations",
        "imprint": "Information and legal",
        "support": "Contact Octopus Order",
        "orderNotificationTimer": "Set your order alarm",
        "intro": "Discover all the features of the app"
      }
    },
    "location": {
      "thank": "@:button.thank",
      "sendMsg": "Send message",
      "create": "Add location",
      "requestSent": "Your request to supplier {deliverer} is being reviewed. A representative will contact you in the coming days.",
      "assignDeliverer": "Assign a supplier to your location",
      "welcome1": "Hello {name}",
      "intro": "In 4 short steps we complete your profile together"
    },
    "noOrders": "You have not placed any orders yet.",
    "noOrdersFilter": "You have not placed any orders in this time frame.",
    "noLists": "You have not created any lists yet.",
    "noNotifications": "You have not received any notifications yet.",
    "noNews": "Sorry, there is currently no Octopus news available.",
    "order": {
      "deliveryType": "Select delivery method",
      "deliveryTime": "Select delivery day",
      "pickupTime": "Select pick-up time",
      "pickup": "Pick up",
      "delivery": "Delivery",
      "overview": "Order overview",
      "choosePayment": "Select payment method",
      "redirectPayment": "In the following step you will be redirected to {target}.",
      "rememberPayment": "Use payment method for future orders.",
      "voucher": "Voucher | Vouchers",
      "redeemVoucher": "@:messages.order.voucher redeem",
      "voucherCode": "Enter voucher code",
      "currentOrders": "My orders",
      "orderProducts": "Your ordered @:object.article",
      "otherProducts": "Other frequently ordered articles",
      "sent": "Your order has been successfully transmitted to {target}.",
      "locationIssue": "Missing pick-up location. Please enter a pick-up location."
    },
    "deliverer": {
      "allDeliverers": "All @:object.deliverer from {location}",
      "addDeliverer": "Add an @:object.deliverer",
      "noEmail": "Please add an email address to the deliverer before you can order"
    },
    "team": {
      "invite": {
        "welcome1": "@:messages.home.welcome1",
        "welcome2": "Invite other employees or partners to the app...",
        "copy": "Or just copy the code and share it:",
        "messenger": "Invite directly via the messenger of your choice:",
        "mail": "By email address",
        "joinTeam": "Join our team",
        "joinTeam2": "You have been invited to the location {location} in the Octopus Order App!\n\nWith this link you can join your team directly.\n\n{inviteLink}\n\nIf this link does not work, you can join your team in the app with the code\n\n{link}\n\nto join your new team.\n\nFor Android: {appLinkAndroid}\n\nFor IOS: {appLinkIOS}",
        "shareHint": "For security reasons, the generated/sent code can only invite basic users. For an invitation with the selected rights, please use the e-mail invitation."
      },
      "management": {
        "members": "Team members from {location}",
        "inviteMember": "Invite team members",
        "addDevice": "Add device",
        "permissionExplanation": "Overview of the rights of our roles:"
      }
    },
    "missingPermission": "Missing permission: {permission}",
    "missingCartOrderPermission": "Your permissions in the app are not sufficient. Please contact the owner of your location to complete an order.",
    "permission": {
      "all": "All permissions",
      "locationOrderHistoryRead": "Read order history",
      "locationListRead": "View lists",
      "locationListItemRead": "View list products",
      "locationListItemCreate": "Create list products",
      "locationListItemUpdate": "Edit list products",
      "locationListItemDelete": "Delete list products",
      "locationListCreate": "Create lists",
      "locationListUpdate": "Edit lists",
      "locationListDelete": "Delete lists",
      "locationCartRead": "View shopping cart",
      "locationCartAdd": "Fill shopping cart",
      "locationCartUpdate": "Edit shopping cart products",
      "locationCartDelete": "Delete shopping cart products",
      "locationOrderCreate": "Create order",
      "locationOrderRequest": "Execute order request",
      "locationRead": "View location",
      "locationCreate": "Create location",
      "locationUpdate": "Edit location",
      "locationDelete": "Delete location",
      "locationTeamRead": "View team",
      "locationTeamMemberAdd": "Add team member",
      "locationTeamMemberDelete": "Delete team member",
      "locationTeamMemberRoleUpdate": "Edit team member roles",
      "locationSupplierRead": "View suppliers",
      "locationSupplierCreate": "Add suppliers",
      "meRead": "Read own user data",
      "meUpdate": "Edit own user data",
      "meDelete": "Delete own user",
      "locationListReminderCreate": "Create order alarm",
      "locationListReminderDelete": "Delete order alarm",
      "locationListReminderRead": "View order alarm",
      "locationListReminderUpdate": "Edit order alarm",
      "locationContactSupplier": "Contact supplier"
    },
    "noListEntries": "There are currently no items in this list",
    "noSearchResults": "No articles found for your filter",
    "noEntries": "No items available",
    "noMail": "No mail received",
    "login": {
      "emailSent": "We just sent you an email",
      "setPassword": "You can set a new password via the link",
      "resetPassword": "Enter your email address and receive a new password"
    },
    "start": {
      "notNew": "Already a customer",
      "new": "First time here"
    },
    "cart": {
      "amount": "{amount} Item positions",
      "selectionFrom": "Selection at {deliverer}",
      "fromList": "From your lists",
      "noList": "Without list",
      "lastOrder": "From your last order",
      "amountItems": "{amount} Single article",
      "upgradeToPromotion": "Almost there! Just {amount} Pieces until the {shortTitle} Action 🏷️ → order now",
      "convertToPromotion": "Action secured 🏷️ → activate now"
    },
    "register": {
      "intro": "To create your profile we need some information",
      "thank": "Thank you {name}",
      "emailSent": "@:messages.login.emailSent",
      "validate": "Please confirm your account via the link",
      "validateEmail": "@:{'messages.register.validate'} sent to your email address before you can order",
      "noCode": "I do not have an invitation code",
      "code": "I have received an invitation code",
      "skipEmail": "Unfortunately, we could not find the email address you entered. Please confirm your e-mail address again."
    },
    "didYouMean": "Are you looking for {target} perhaps?",
    "didYouCheck": "Have you searched all suppliers in the previous view?",
    "agbRequired": "You have to agree to the privacy policy.",
    "list": {
      "repeatEach1": "Reminder",
      "repeatEach2": "All",
      "noTags": "No filter categories available. Add categories to your list products.",
      "overrideCartList": "The list is already in the shopping cart. Do you want to overwrite your shopping cart?",
      "overrideProductList": "This product is already in your shopping cart. Do you want to overwrite your shopping cart?",
      "noReminder": "No order alarms have yet been created for this list.",
      "amountReset": "The product quantities have been reset.",
      "resetCheck": "Are you sure you want to reset all the quantities in this list to 0?"
    },
    "pressEnter": "Confirm on keyboard to add",
    "changedEmail": "We have just sent you an email to the new address. To apply the change, please click on the link sent.",
    "updateLoading": "Update is being installed",
    "intro": {
      "home": {
        "msg1": "Click on the header to return to your location overview and shopping cart.",
        "title1": "Reach your locations and the shopping cart",
        "msg2": "Your most recent orders and frequently ordered lists can be accessed directly via the dashboard.",
        "title2": "Overview of your activities",
        "msg3": "Use the menu bar to reach your destination with just one click.",
        "title3": "Navigation accessible everywhere"
      },
      "list": {
        "title1": "The order starts here",
        "msg1": "You can access your lists and the catalogue via the header. Here you can search the articles of your suppliers.",
        "title2": "Your suppliers",
        "msg2": "Here you can view and edit the order lists of your suppliers or create new lists yourself.",
        "title3": "Sorting and deleting",
        "msg3": "Tap the product image to select individual or multiple items, move them using drag & drop, or delete them using the bin icon.",
        "title4": "Easily customise the list",
        "msg4": "The quantity of a product can be changed using the plus and minus buttons. Swipe right to remove the product from the list.",
        "title5": "Find items quickly",
        "msg5": "In the catalogue you can view and search the individual items of your suppliers and filter them by category."
      },
      "promotion": {
        "title1": "Promotions and suggestions",
        "msg1": "Here you can see current promotions, product suggestions or news from your suppliers or from Octopus Order.",
        "title2": "Promotional offers from your suppliers",
        "msg2": "Here you can see articles from your suppliers for which special offers are currently available.",
        "title3": "Current suggestions and news",
        "msg3": "The product suggestions provide you with information on the latest trends in the beverage industry. In the News section you can find out all the latest news about Octopus."
      },
      "setting": {
        "msg1": "Here you can manage your suppliers and locations, make settings, view orders or contact support.",
        "title1": "App settings",
        "msg2": "You can set alarms here to remind you regularly to order your list.",
        "title2": "Never forget an order again",
        "msg3": "Here you can manage your team and invite other team members to Octopus Order.",
        "title3": "Your own team",
        "msg4": "Here you have an overview of all your suppliers and can edit or remove them as well as add new suppliers.",
        "title4": "Supplier overview"
      }
    },
    "ordering": "Order is being executed",
    "noConnection1": "No connection to server",
    "noConnection2": "Please check your internet connection",
    "switchLocation": "The notification belongs to another location. Do you want to change location?",
    "containsExpiredPromotion": "There is an expired promotional item in your shopping cart. Please remove it to proceed with your order.",
    "addProductsViaScanner": "Add products via scanner",
    "scanDesiredProducts": "Scan your desired products",
    "scanToAddMoreProducts": "Scan to add more products",
    "updateScanItems": "Would you like to add your scanned items to your list? The number of items in the list will be overwritten.",
    "addScanItems": "Would you like to add your scanned items to the shopping basket?",
    "holidayDeliveryTitle": "The selected delivery day is a public holiday!",
    "holidayDelivery": "Please ask your supplier for your exact delivery date.",
    "longOrder": "Your order is more than 7 days in the future. Do you really want to order at {date}?",
    "cartDataMissing": "Order data incorrect",
    "newBinaryVersion": "A new version is available and contains important changes. Please update your version.",
    "deliveryDayWarningTitle": "The selected date is not a regular delivery day!",
    "deliveryDayWarning": "Please clarify exceptional cases with the supplier in advance.",
    "holidayPickupTitle": "The selected collection day is a public holiday!",
    "holidayPickup": "Please ask your supplier for your exact collection date.",
    "modal": {
      "updateLocationTypeTitle": "Your choice, your advantage",
      "updateLocationTypeDescription": "When you select your catering business, we customise content and promotions for you. You can change this setting at any time.",
      "updateLocationTypeHint": "The selection is only used within the app and can be customised at any time."
    },
    "currentLocation": "You are currently in the location"
  },
  "object": {
    "order": "Order | Orders",
    "article": "Item positions",
    "promotion": "Action | Actions",
    "location": "Location",
    "cart": "Shopping cart",
    "list": "List | Lists",
    "filter": "Filter",
    "message": "News | News",
    "catalog": "Catalogue",
    "notification": "Notification | Notifications",
    "notificationOption": "@:object.notification {'options'}",
    "setting": "Settings",
    "intro": "Apptour",
    "home": "Home",
    "dark": "Dark",
    "light": "Light",
    "zip": "POSTCODE",
    "city": "City",
    "street": "Street",
    "lastname": "Name",
    "firstname": "First name",
    "address": "Address",
    "zipCity": "@object:zip, @object:city",
    "profile": "Profile",
    "pointSystem": "Point system",
    "amount": "Quantity",
    "price": "Unit price",
    "total": "Total price",
    "notAvailable": "Price information not available",
    "sort": "Sort",
    "alphabetic": "Alphabetical",
    "filterCategory": "@:object.filter{'category'}",
    "priceRange": "Price range",
    "team": "Team",
    "deliverer": "Supplier | Suppliers",
    "display": "Display options",
    "statistic": "Statistics",
    "imprint": "Imprint",
    "law": "Legal",
    "support": "Octopus Order Support",
    "filterOption": {
      "spirits": "Spirits",
      "nonAlcoholic": "Non-Alcoholic Beverages",
      "beer": "Beer",
      "gastro": "Gastro needs",
      "wine": "Wine",
      "food": "Food",
      "nonFood": "Non Food",
      "other": "Other"
    },
    "suggestion": "Product{suggestion} | Product{suggestion}",
    "news": "News",
    "days": "Days | Day",
    "hours": "Hours | Hour",
    "minutes": "Minutes | Minute",
    "validFor": "Valid for {value}",
    "validUntil": "Valid until",
    "expired": "Expired",
    "totalPosition": "Total position",
    "totalOrder": "Total order value"
  },
  "enumT": {
    "pinned": "Pinned",
    "new": "New",
    "restocked": "Available again",
    "reduced": "On offer",
    "notInStock": "With delivery time",
    "promotion": "Promotional item",
    "issueType": {
      "bug": "Bug",
      "feature": "Feature"
    },
    "contactWay": {
      "none": "Please do not contact",
      "email": "Email",
      "phone": "Phone",
      "emailOrPhone": "Email or phone"
    },
    "sortDirection": {
      "asc": "Ascending Alphabetical",
      "desc": "Descending Alphabetical",
      "catFilter": "By own category",
      "catSupplier": "By supplier category",
      "manually": "Manual sorting"
    },
    "weekday": {
      "mon": "Monday",
      "tue": "Tuesday",
      "wed": "Wednesday",
      "thu": "Thursday",
      "fri": "Friday",
      "sat": "Saturday",
      "sun": "Sunday"
    },
    "repeatCycle": {
      "once": "unique",
      "week": "weekly",
      "month": "monthly",
      "appendix": {
        "week": "week(s)",
        "month": "month(s)"
      }
    },
    "month": {
      "january": "January",
      "february": "February",
      "march": "March",
      "april": "April",
      "may": "May",
      "june": "June",
      "july": "July",
      "august": "August",
      "september": "September",
      "october": "October",
      "november": "November",
      "december": "December"
    }
  },
  "modal": {
    "selection": "Choices",
    "addList": "Add to list",
    "addCart": "Add to shopping cart",
    "openCatalog": "Open in catalogue"
  },
  "success": {
    "addReminder": "Order alarm clock was added",
    "editReminder": "Order alarm saved",
    "deleteReminder": "Order alarm was deleted",
    "addCart": "Product has been added to the shopping cart. | product was added to the shopping cart",
    "addPromoPackage": "Promotional package was added to the shopping basket.",
    "addCartNumber": "{target} Single items from {target2} item positions were added to the shopping cart",
    "addList": "Product has been added to the list. | Products have been added to the list.",
    "order": "List has been ordered.",
    "save": "{target} was successfully saved. | {target} have been successfully saved.",
    "resendMail": "Email was resent.",
    "copyLink": "Link was copied",
    "sendLink": "Link was sent.",
    "removeProduct": "Product has been removed from the shopping cart. | Product has been removed from the shopping cart.",
    "orderFinish": "Order was created.",
    "delete": "{target} has been deleted.",
    "deleteUser": "User has been deleted",
    "deleteMulti": "{amount} {target} have been deleted.",
    "send": "{target} has been sent.",
    "create": "{target} was created.",
    "edit": "{target} has been successfully edited.",
    "add": "{target} has been added.",
    "deleteTeam": "User has been removed by the team.",
    "setRole": "User role was successfully set",
    "joinLocation": "Location was successfully added",
    "sendInvite": "Invitation email has been sent.",
    "sendTicket": "We have received your feedback. Thank you very much.",
    "aiCall": "The Octobot will call you shortly."
  },
  "success.": "Campaign successful",
  "alert": {
    "delete": {
      "account": "Do you want to permanently delete your account and all associated locations?",
      "reminder": "Do you really want to delete this order alarm?",
      "location": "Do you really want to delete this location?",
      "list": "Do you really want to delete the list \"{target}\"?",
      "noList": "Do you want to remove all products from your shopping basket?",
      "cartSupplier": "Do you want to empty your shopping basket at \"{target}\"?",
      "cartProduct": "Do you really want to delete the product \"{target}\" from the shopping cart?",
      "cartList": "Do you really want to remove the list \"{target}\" and all related items from the shopping cart?",
      "product": "Do you really want to delete the product \"{target}\" from the list? | Do you really want to delete the selected products from the list?",
      "supplier": "Do you want to remove {name} from your suppliers? Attention: Removing a supplier also removes all lists for this supplier.",
      "member": "Do you really want to remove {target}\" from the team?",
      "tag": "Do you really want to remove \"{target}\" from your categories?",
      "customSupplier": "Do you really want to delete this supplier?",
      "scanProduct": "Do you really want to remove the product \"{target}\" from your scanned items?"
    },
    "delivererSuccess": "The supplier was successfully added",
    "delivererError": "Error",
    "delivererSuccessMessage": "We have added {target} to your location.",
    "delivererErrorMessage": "{target} could not be added to your location. Please check the data you entered.",
    "selectList": "Choose a list",
    "selectSupplier": "Choose a supplier",
    "noList": "No list available for this supplier.",
    "noSupplier": "No supplier available for this item",
    "discardFormTitle": "Attention!",
    "noInternet": "Not all offline data could be synchronised. Please check your internet connection.",
    "compatibilityMode": "You have activated the compatibility mode. While this is active, you can only order via the web portal. Your specified quantity is now in the shopping cart. If you want to order via the app, deactivate this mode in the list settings.",
    "discardForm": "Your data will not be saved. Leave the page anyway?",
    "syncing": "Lists are synchronised",
    "logout": "Do you really want to deregister?",
    "upgradeToPromotion": "Use promotion now? Quantity is automatically adjusted to minimum quantity ({target})",
    "convertToPromotion1": "Apply action?",
    "convertToPromotion2": "{target1} Promotional item, {target2} regular",
    "orderAmountOverLimit": "Limit reached: {isAmount} Promotional item in shopping basket. Max. +{availableAmount} possible",
    "scannerNotActivated": "The scanner function is currently not supported by your suppliers!",
    "scannerAvailableOnlyInApp": "The scanner function is only available in the app!",
    "addLastOrderToCart": "Would you like to add all the items and quantities from your last order to your basket again?"
  },
  "titleRoute": {
    "locationData": "Create location",
    "locationCreate": "@:titleRoute.locationData",
    "locationDeliverer": "Select supplier",
    "locationAdd": "Add location",
    "locationJoin": "Join location",
    "addLocationDeliverer": "Add supplier",
    "editLocationDeliverer": "Edit supplier",
    "settingProfile": "Profile",
    "settingLocation": "Edit location",
    "settingOrder": "Order | Orders",
    "settingOrderDetail": "Order details",
    "settingTeam": "Team",
    "settingTeamInvite": "Invite team",
    "settingDeliverer": "Suppliers",
    "settingDelivererSelect": "Choose supplier",
    "settingNotification": "Notifications",
    "settingDisplay": "Display options",
    "settingSupport": "Support",
    "settingLegal": "Legal",
    "cart": "Shopping cart",
    "orders": "Orders",
    "filter": "Filter",
    "addList": "Create list",
    "editList": "Edit list",
    "notificationDetails": "@:titleRoute.settingNotification",
    "orderNotificationTimer": "Order alarm",
    "changePassword": "Change password",
    "addProduct": "Add product",
    "editProduct": "Edit product",
    "agb": "Privacy policy",
    "news": "Octopus News",
    "suggestion": "Product proposal",
    "productDetails": "Product details",
    "promotionDetails": "Action details",
    "productPresentation": "@:titleRoute.productDetails",
    "promotion": "@:titleRoute.promotionDetails",
    "settingIntro": "Apptour",
    "feedback": "Create feedback",
    "scanner": "Scanner",
    "skipEmail": "Email verification",
    "deleteLocations": "Deleted locations",
    "aiCall": "AI order"
  },
  "placeholder": {
    "search": "Search",
    "selectSize": "Select size",
    "selectVariant": "Select variant",
    "location": {
      "name": "Name of your location",
      "type": "Type of location",
      "zip": "Postcode",
      "ownZip": "Postcode of your own location",
      "city": "City",
      "street": "Street",
      "streetNumber": "No.",
      "phone": "Telephone number",
      "internationalPhone": "International telephone number",
      "deliverer": "@:select object.deliverer",
      "customerNumber": "@:label.customerNumber enter"
    },
    "email": "Email",
    "newEmail": "New email",
    "oldPassword": "Old @:input.password",
    "password": "@:input.password",
    "passwordRepeat": "@:input.password repeat",
    "sendMessageDeliverer": "Send a message to {deliverer} ...",
    "inviteCode": "Enter invitation code",
    "firstName": "@:label.firstName",
    "lastName": "@:label.lastName",
    "name": "Name",
    "phone": "@:placeholder.location.phone",
    "street": "Street",
    "zip": "POSTCODE",
    "city": "City",
    "alphabetic": "Alphabetical",
    "customerNumber": "Customer number",
    "customerNumberPlus": "Customer number/Sales outlet number",
    "quickstart": "Quickstart Code",
    "paymentMethod": "Payment method",
    "pickupMethod": "Location",
    "deliveryDate": "Delivery date",
    "emailOrPhone": "@:placeholder.email",
    "code": "Invitation code",
    "packaging": "Pack size",
    "searchOrAdd": "Search or add category",
    "tagName": "Category name",
    "pickupLocation": "Pick up in",
    "pickupDate": "Collection time",
    "quantity": "Quantity",
    "eancode": "EAN-Code",
    "customSupplierType": "Supplier type",
    "issueType": "Feedback type",
    "title": "Title",
    "bug": {
      "issue": "What is the problem?",
      "place": "Where does the problem occur?",
      "expectation": "What behaviour would you expect instead of the current behaviour?",
      "steps": "What steps were taken until the bug occurred? / How can the bug be reproduced?"
    },
    "feature": {
      "expectation": "What additional function would you like to see?",
      "place": "Where are you missing the desired function?"
    },
    "select": "Select",
    "contactWay": "How may we contact you for questions and updates?"
  },
  "option": {
    "industry": {
      "PRIVATE": "Private",
      "GETRAENKEFACHGROSSHANDEL": "Drinks wholesale",
      "LEBENSMITTEL_GROSSHANDEL": "Food wholesale",
      "HANDELSWAREN_ALLGEMEIN": "General merchandise",
      "SONSTIGE": "Other"
    },
    "customSupplierType": {
      "meat": "Meat supplier",
      "vegetable": "Vegetables",
      "drinks": "Drinks",
      "hygiene": "Hygiene articles",
      "other": "Other"
    }
  }
}

export default en;